
import {
	Component, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class AmountChip extends Vue {
	@Prop()
	public id!: string;

	@Prop()
	public contentClass!: string;
}
